import Chart from "../../../components/dashboard/Chart";

interface IncomeChartProps {
  earnings?: {
    currentMonth: number;
    lastMonth: number;
    ytd: number;
    monthlyBreakdown: Array<{
      month: string;
      year: string;
      timestamp: number;
      earnings: number;
    }>;
  };
  isLoading?: boolean;
}

const IncomeChart = ({ earnings, isLoading }: IncomeChartProps) => {
  const transformEarningsData = () => {
    if (!earnings?.monthlyBreakdown) {
      return [];
    }

    return earnings.monthlyBreakdown.map((item) => ({
      name: `${item.month} '${item.year.slice(-2)}`,
      income: item.earnings,
    }));
  };

  const chartData = transformEarningsData();
  const loading = isLoading || !earnings;

  return (
    <div className="bg-[#f9f9f9] rounded-2xl p-4 mt-4">
      <div className="text-sm font-semibold text-[#767677] mb-4">
        Monthly earnings
      </div>
      <div className="rounded-[15px] bg-[#f9f9f9] -ml-12 md:-ml-8">
        <Chart
          title="Test"
          type="area"
          data={chartData}
          categories={["income"]}
          // SDS Green 100
          colors={["#83b300"]}
          height={300}
          showLegend={false}
          isLoading={loading}
          hideGrid={false}
          formatYAxis={true}
          className="bg-transparent shadow-none border-0 [&>div:first-child]:hidden [&>div:last-child]:!p-0 [&>div:last-child]:!px-0"
        />
      </div>
    </div>
  );
};

export default IncomeChart;
